/* «¿Cuánto es?»: una calculadora de bolsillo. Tecleas el precio y sale en la otra moneda, en grande y sin red.
   Por defecto de yenes a euros (lo de las etiquetas); ⇄ le da la vuelta. El cambio es el de los gastos. */
import { useState } from 'react';
import { cambioDe, useApuntes } from '../datos/apuntes.ts';
import type { Viaje } from '../datos/tipos.ts';
import { Hoja } from '../componentes/Hoja.tsx';
import { euros, miles } from '../texto.ts';

const RAPIDOS = [100, 500, 1000, 3000, 5000, 10000];
const TECLAS = ['7', '8', '9', '4', '5', '6', '1', '2', '3', '00', '0', '⌫'];

export function HojaCuanto({ v, onCerrada }: { v: Viaje; onCerrada: () => void }) {
  useApuntes();
  const cambio = cambioDe(v.viaje.yenPorEuro);
  const [deYen, setDeYen] = useState(true);
  const [cifra, setCifra] = useState('');
  const n = Number(cifra.replace(',', '.')) || 0;
  const tecla = (t: string) => setCifra(c => {
    if (t === '⌫') return c.slice(0, -1);
    if (t === ',') return deYen || c.includes(',') ? c : (c || '0') + ',';
    const [ent, dec] = c.split(',');
    if (dec !== undefined ? dec.length + t.length > 2 : ent.length + t.length > 8) return c;    // hasta ¥99.999.999 o 2 decimales
    return (c + t).replace(/^0+(?=\d)/, '');
  });
  const arriba = deYen ? `¥ ${miles(n)}` : euros(n, cifra.includes(',') ? 2 : 0);
  const abajo = deYen ? euros(n / cambio, 2) : `¥ ${miles(Math.round(n * cambio))}`;
  return (
    <Hoja id="hoja-cuanto" titulo="cuanto-titulo" clase="hoja--cuanto" onCerrada={onCerrada}>
      {() => (
        <>
          <p className="hoja__kicker">両替 · 1 € = {miles(cambio)} ¥</p>
          <h2 id="cuanto-titulo">¿Cuánto es?</h2>
          <div className="cuanto__pantalla" aria-live="polite">
            <p className="cuanto__de">{cifra ? arriba : deYen ? 'Escribe el precio en yenes' : 'Escribe el precio en euros'}</p>
            <p className="cuanto__a">{cifra ? abajo : deYen ? '0,00 €' : '¥ 0'}</p>
          </div>
          <div className="cuanto__rapidos" role="group" aria-label="Precios rápidos">
            {deYen
              ? RAPIDOS.map(r => <button key={r} type="button" onClick={() => setCifra(String(r))}>¥{miles(r)}</button>)
              : [1, 5, 10, 20, 50, 100].map(r => <button key={r} type="button" onClick={() => setCifra(String(r))}>{r} €</button>)}
          </div>
          <div className="cuanto__teclado">
            {TECLAS.map(t => (
              <button key={t} type="button" aria-label={t === '⌫' ? 'Borrar' : undefined} onClick={() => tecla(t === '00' && !deYen ? ',' : t)}>
                {t === '00' && !deYen ? ',' : t}
              </button>
            ))}
          </div>
          <div className="cuanto__pie">
            <button type="button" className="accion" onClick={() => { setDeYen(d => !d); setCifra(''); }}>⇄ {deYen ? 'De euros a yenes' : 'De yenes a euros'}</button>
            <button type="button" className="accion" disabled={!cifra} onClick={() => setCifra('')}>Borrar todo</button>
          </div>
          <p className="texto" style={{ fontSize: '.8rem' }}>Funciona sin conexión. El cambio se ajusta en Guía → Cambio y vale también para los gastos.</p>
        </>
      )}
    </Hoja>
  );
}
